import React, { memo } from 'react';
import { CustomTooltip } from '@components/CustomTooltip';
import { clearMultiSelection } from '@components/MainStage/clearMultiSelection';
import { useMultiSelectionCount } from '@components/MainStage/multiSelection.store';
import { Typography } from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import { CloseIcon } from '@utils/iconsDefs';

import {
  ClearButton,
  MultiSelectionBadgeStyled,
} from './MultiSelectionBadge.styled';

export const MultiSelectionBadge = memo(function MultiSelectionBadge() {
  const count = useMultiSelectionCount();

  if (count === 0) return null;

  return (
    <MultiSelectionBadgeStyled>
      <Typography
        variant="body2"
        color={themePalette.system.success}
        sx={{ fontWeight: 600 }}
      >
        {count} Selected
      </Typography>

      <CustomTooltip title="Clear all selected entities" placement="top" arrow>
        <ClearButton
          type="button"
          aria-label="Clear selection"
          onClick={() => clearMultiSelection()}
        >
          <CloseIcon
            width={12}
            height={12}
            fill={themePalette.system.success}
          />
        </ClearButton>
      </CustomTooltip>
    </MultiSelectionBadgeStyled>
  );
});
